import type { ApplicantCreation } from 'cpool-schemas';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormDateInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormDateInput';
import { FormCurrencyInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormCurrencyInput';
import { TextInput } from 'cpool-components/input/TextInput';

const basePath = 'beschaeftigung.azubi' as const;

export const Azubi: React.FC = () => {
    const { t } = useTranslation();
    const { control, register } = useFormContext<ApplicantCreation>();

    return (
        <div className="mt-4 space-y-2">
            <p className="text-sm text-midnight text-center">
                {t('CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT.SUBSECTIONS.INCOME_HEALTH_INSURANCE')}
            </p>

            <FormCurrencyInput
                id={`${basePath}.ausbildungsVerguetungMonatlich` as Path<ApplicantCreation>}
                label={t('CREDIT_WORTHINESS.SECTIONS.INCOME.TRAINING_COMPENSATION')}
                control={control}
                min={0}
            />

            <FormDateInput
                id={`${basePath}.endeDerAusbildung` as Path<ApplicantCreation>}
                label={t('CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT.END_OF_TRAINING')}
                control={control}
            />

            <TextInput
                id={`${basePath}.schulName`}
                label={t('CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT.SCHOOL_NAME')}
                labelClassName="w-[175px] justify-start"
                {...register(`${basePath}.schulName` as Path<ApplicantCreation>)}
            />

            <TextInput
                id={`${basePath}.schulStandort`}
                label={t('CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT.SCHOOL_LOCATION')}
                labelClassName="w-[175px] justify-start"
                {...register(`${basePath}.schulStandort` as Path<ApplicantCreation>)}
            />
        </div>
    );
};
